$(document).ready(function(){
  $(".page-faq-s #shopify-section-template--14887814660233__1649716995910d97bf .accordion-container-menu").addClass("active");
  
  
  
  $(".accordion-container-menu").each(function(inde){
    $(this).on("click", function(){
      $(".accordion-container").css("display", "none");
      $(".accordion-container-menu").removeClass("active");
      $(this).next().css("display", "table");
      $(this).addClass("active");
    });
    
  });
  
  var window_scroll = $(window).scrollTop();

  if (window_scroll >= 1) 
     $('.sticky_header').addClass('fixed');
  else 
     $('.sticky_header').removeClass('fixed');


  
  $(window).scroll(function(){
    var window_scroll = $(window).scrollTop();

    if (window_scroll >= 1) 
      $('.sticky_header').addClass('fixed');
    else 
      $('.sticky_header').removeClass('fixed');
  });
  
  //$('#globo-formbuilder-80715,#globo-formbuilder-79292').on('click', '.submit', function(event) {
  $(document).on('click', '#globo-formbuilder-80715 .submit,#globo-formbuilder-79292 .submit,#globo-formbuilder-81761 .submit' ,function (event) {
     console.log('test');
     var $this = $(this).closest('form');
     var email = $this.find("input[name=email]").val();
     var confirmemail = $this.find("input[name=email-2]").val();
     if(email != '' && email != confirmemail) {
        $this.find("input[name=email-2]").next().html('Email and Confirm Email Not Matching!');
     	$this.find("block-container").addClass('errors');
        $this.addClass('errors');
        event.preventDefault();
        return false; 
     }else{
     	$this.find("input[name=email-2]").next().html('');
        $this.find("block-container").addClass('errors');
        $this.addClass('errors');
     }
  });
  
  
});